import React from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

const OurClients = () => {
  return (
    <div className="bg-yellow">
      <div className="md:grid grid-cols-1 py-4 place-items-center gap-3 ">
      <div className="space-y-4">
          <div className="text-center">
            <div>
                <h1 className="text-red font-bold">Our Clients</h1>
            </div>
          </div>
        </div>
        </div>
      <div className="md:grid grid-cols-4 py-4 place-items-center gap-3 px-10">
        <div className="space-y-4">
          <div className="text-center">
            <div>
                <img src="/static/images/Del_Monte_logo.png" width="80px" />
            </div>
          </div>
        </div>
        
        <div className="space-y-4">
          <div className="text-center">
            <div>
                <img src="/static/images/Dole_Logo.png" width="80px" />
            </div>
          </div>
        </div>
        
        
        <div className="space-y-4">
          <div className="text-center">
            <div>
                <img src="/static/images/dow.png" width="80px" />
            </div>
          </div>
        </div>
        
        <div className="space-y-4">
          <div className="text-center">
            <div>
                <img src="/static/images/reddys.jpg" width="80px" />
            </div>
          </div>
        </div>
        <div className="space-y-4">
          <div className="text-center">
            <div>
                <img src="/static/images/basf.png" width="80px" />
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <div className="text-center">
            <div>
                <img src="/static/images/ig_blue_berries.png" width="80px" />
            </div>
          </div>
        </div>
        <div className="space-y-4">
          <div className="text-center">
            <div>
                <img src="/static/images/Stemilt-logo.png" width="80px" />
            </div>
          </div>
        </div>
        <div className="space-y-4">
          <div className="text-center">
            <div>
                <img src="/static/images/edeka.png" width="80px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurClients;
